import React, { useEffect, useRef } from "react";
import "./Heading01.scss";

// Libraries & Packages
import { motion, useAnimation, useInView } from "framer-motion";

function Heading01({ children = "Default Text" }) {
  // Ref
  const refHeading01Border = useRef(null);
  const refHeading01Text = useRef(null);

  // Framer Motion
  const controlsHeading01 = useAnimation();

  const isHeading01BorderInView = useInView(refHeading01Border, {
    once: false,
  });

  // Effect
  useEffect(() => {
    if (isHeading01BorderInView) {
      controlsHeading01.start({
        width: "100%",
        transition: { duration: 1, delay: 0.5 },
      });
    }
  }, [isHeading01BorderInView, controlsHeading01]);

  return (
    <div className="heading01">
      <motion.div ref={refHeading01Text}>{children}</motion.div>
      <div className="heading01__underline__container">
        <motion.div
          ref={refHeading01Border}
          initial={{ width: "0%", left: 0 }}
          animate={controlsHeading01}
        ></motion.div>
      </div>
    </div>
  );
}

export default Heading01;
